// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../demo-rental-history/state/criteria';
import actions from '../../actions-list';

const updateDemoRentalAttributesCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const updateDemoRentalAccountsCriteria = (state, action) =>
    Criteria.update(state, {
        dealers: {
            $set: action.selectedAccounts
        }
    });

const updateBeginDate = (state, action) =>
    Criteria.update(state, {
        beginDate: {
            from: {
                $set: action.beginDateRange.from
            },
            to: {
                $set: action.beginDateRange.to
            }
        }
    });

const updateEndDate = (state, action) =>
    Criteria.update(state, {
        endDate: {
            from: {
                $set: action.endDateRange.from
            },
            to: {
                $set: action.endDateRange.to
            }
        }
    });

const updateSelectAllDealers = (state, action) => {

    const selectedDealers = state.dealers.length ? [] : action.dealers;

    return Criteria.update(state, {
        dealers: {
            $set: selectedDealers
        }
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DEMO_RENTAL_ACCOUNTS_CRITERIA]: updateDemoRentalAccountsCriteria,
        [actions.UPDATE_DEMO_RENTAL_ATTRIBUTES_CRITERIA]: updateDemoRentalAttributesCriteria,
        [actions.UPDATE_DEMO_RENTAL_BEGIN_DATE]: updateBeginDate,
        [actions.UPDATE_DEMO_RENTAL_END_DATE]: updateEndDate,
        [actions.UPDATE_DEMO_RENTAL_SELECT_ALL_ACCOUNTS_CRITERIA]: updateSelectAllDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/reducers/criteria.js